import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../config/config.service';
import { CreateSafraDTO, Safra, UpdateSafraDTO } from '../types/Safra.type';

@Injectable({
    providedIn: 'root'
})
export class SafraService {

    constructor(private httpClient: HttpClient, private configService: ConfigService) { }

    findAll():Observable<Safra[]> {
        return this.httpClient.get<Safra[]>(`${this.configService.getApiUrl()}/corporativo/safras`);
    }

    findById(id: number): Observable<Safra> {
        return this.httpClient.get<Safra>(`${this.configService.getApiUrl()}/corporativo/safras/${id}`)
    }

    create(safra: CreateSafraDTO) {
        return this.httpClient.post<CreateSafraDTO>(`${this.configService.getApiUrl()}/corporativo/safras`, safra);
    }

    update(safra: UpdateSafraDTO) {
        return this.httpClient.put<UpdateSafraDTO>(`${this.configService.getApiUrl()}/corporativo/safras`, safra);
    }

    delete(id: number) {
        return this.httpClient.delete<void>(`${this.configService.getApiUrl()}/corporativo/safras/${id}`);
    }

    actived(id: number) {
        return this.httpClient.put<void>(`${this.configService.getApiUrl()}/corporativo/safras/${id}/ativar`, null);
    }
}
